export const TEXTS = {
    SORT_BY: "Sort By",
    FILTER_BY: "Filter By",
    FILTER: "Filter",
    SORT: "Sort",
    CLEAR_FILTERS: "Clear Filters",
    APPLY: "Apply",
};

export const SORT_ID_FILTERS = "sortAttribute";
export const SORT_DISH_ID = "sortKey";
export const SORT_KEY_VERTICAL_NAVIGATION = "sort";
export const MWEB_BOTTOM_SHEET = "mwebBottomSheet";
export const DWEB_BOTTOM_SHEET = "dwebBottomSheet";

export const COMMON_IDS = {
    SORT_CONTAINER: "sort-container",
};

export const ACTIONS = {
    HALF_CARD_CONTENT_APPLY_FILTERS: "halfCardContentApplyFilters",
    CLEAR_FILTERS: "clearFilters",
    PILL_SELECTED_FILTERS_CLICK: "pillSelectedFiltersClick",
    PILL_UNSELECTED_FILTERS_CLICK: "pillUnselectedFiltersClick",
    SORT_CHANGE: "sortChange",
};

export const TOAST_MESSAGE = {
    CLEAR_FILTERS: "The applied filters are cleared",
};

export const STICKY_OFFSET = 60;
